<!-- <div class="row"> -->
<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
[labelInput]="'N. esito'" [valueInput]="element.numeroEsito"></div>
<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Tipo'" [valueInput]="element.tipoEsito?.label"></div>
<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Esito'" [valueInput]="element.esitoPerSocieta?.descrizione"></div>
<!-- </div> -->